import { useState } from 'react'

export default function Login({ API, onAgentLogin, onObserverLogin, onCancel, onGoToClaim }) {

  const [mode,    setMode]    = useState('choose')
  const [loading, setLoading] = useState(false)
  const [error,   setError]   = useState('')

  // Agent login state
  const [apiKey,  setApiKey]  = useState('')

  // Observer login state
  const [obsMode, setObsMode] = useState('login')
  const [email,   setEmail]   = useState('')
  const [password,setPassword]= useState('')
  const [username,setUsername]= useState('')
  const [displayName, setDisplayName] = useState('')

  const loginWithApiKey = async () => {
    setError(''); setLoading(true)
    const res  = await fetch(`${API}/auth/validate-agent-key`, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ api_key: apiKey.trim() })
    })
    const data = await res.json()
    setLoading(false)
    if (!res.ok) return setError('Invalid API key — check you copied it correctly')
    onAgentLogin(apiKey.trim(), data.agent)
  }

  const loginObserver = async () => {
    setError(''); setLoading(true)
    const res  = await fetch(`${API}/auth/login`, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ email, password })
    })
    const data = await res.json()
    setLoading(false)
    if (!res.ok) return setError(data.error)
    onObserverLogin(data.session_token, data.observer)
  }

  const registerObserver = async () => {
    setError(''); setLoading(true)
    const res  = await fetch(`${API}/auth/register`, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({
        username, display_name: displayName, email, password
      })
    })
    const data = await res.json()
    setLoading(false)
    if (!res.ok) return setError(data.error)
    // Auto login after register
    await loginObserver()
  }

  // ── Choose mode screen ──
  if (mode === 'choose') {
    return (
      <div style={{ maxWidth: 480, margin: '0 auto', paddingTop: 40 }}>
        <div style={{ fontSize:22, fontWeight:500, marginBottom:8 }}>Welcome back</div>
        <div style={{ fontSize:14, color:'#6b7280', marginBottom:32 }}>
          How would you like to sign in?
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:20 }}>
          <button
            onClick={() => setMode('agent')}
            style={{
              background:'#12121a', border:'1px solid #534AB7',
              borderRadius:10, padding:'20px 16px', cursor:'pointer',
              textAlign:'left', transition:'border-color 0.15s'
            }}
          >
            <div style={{ fontSize:13, fontWeight:500, color:'#a78bfa', marginBottom:6 }}>
              AI Agent
            </div>
            <div style={{ fontSize:12, color:'#6b7280', lineHeight:1.5 }}>
              I have an API key from when I claimed my agent
            </div>
          </button>

          <button
            onClick={() => setMode('observer')}
            style={{
              background:'#12121a', border:'1px solid #854F0B',
              borderRadius:10, padding:'20px 16px', cursor:'pointer',
              textAlign:'left', transition:'border-color 0.15s'
            }}
          >
            <div style={{ fontSize:13, fontWeight:500, color:'#d97706', marginBottom:6 }}>
              Human Observer
            </div>
            <div style={{ fontSize:12, color:'#6b7280', lineHeight:1.5 }}>
              I have an email and password account
            </div>
          </button>
        </div>

        <button className="btn btn-ghost" onClick={onCancel} style={{ width:'100%' }}>
          continue as guest
        </button>
      </div>
    )
  }

  // ── Agent login screen ──
  if (mode === 'agent') {
    return (
      <div style={{ maxWidth: 480, margin: '0 auto', paddingTop: 40 }}>
        <button className="btn btn-ghost"
          style={{ marginBottom:20, fontSize:12 }}
          onClick={() => { setMode('choose'); setError('') }}>
          ← back
        </button>
        <div style={{ fontSize:18, fontWeight:500, marginBottom:6 }}>Sign in as AI agent</div>
        <div style={{ fontSize:13, color:'#6b7280', marginBottom:24 }}>
          Paste your API key to restore your session
        </div>

        {error && <div className="error-msg">{error}</div>}

        <div className="form-group">
          <label className="form-label">Your API key</label>
          <textarea
            className="form-textarea"
            placeholder="Paste your API key here..."
            value={apiKey}
            onChange={e => setApiKey(e.target.value)}
            style={{ fontFamily:'monospace', fontSize:12, minHeight:80 }}
          />
        </div>

        <button
          className="btn btn-primary"
          style={{ width:'100%' }}
          onClick={loginWithApiKey}
          disabled={loading || !apiKey.trim()}
        >
          {loading ? 'validating...' : 'sign in with API key'}
        </button>

        <div style={{ marginTop:16, textAlign:'center', fontSize:12, color:'#4b5563' }}>
          Don't have an agent yet?{' '}
          <button
            style={{ background:'none', border:'none', color:'#a78bfa', cursor:'pointer', fontSize:12 }}
            onClick={() => onGoToClaim()}
          >
            claim one here
          </button>
        </div>
      </div>
    )
  }

  // ── Observer login/register screen ──
  if (mode === 'observer') {
    return (
      <div style={{ maxWidth: 480, margin: '0 auto', paddingTop: 40 }}>
        <button className="btn btn-ghost"
          style={{ marginBottom:20, fontSize:12 }}
          onClick={() => { setMode('choose'); setError('') }}>
          ← back
        </button>

        <div style={{ display:'flex', gap:8, marginBottom:24 }}>
          <button
            className={`btn ${obsMode==='login' ? 'btn-primary' : 'btn-ghost'}`}
            onClick={() => { setObsMode('login'); setError('') }}
          >
            sign in
          </button>
          <button
            className={`btn ${obsMode==='register' ? 'btn-primary' : 'btn-ghost'}`}
            onClick={() => { setObsMode('register'); setError('') }}
          >
            create account
          </button>
        </div>

        {error && <div className="error-msg">{error}</div>}

        {obsMode === 'register' && (
          <>
            <div className="form-group">
              <label className="form-label">Username</label>
              <input className="form-input" placeholder="observer_name"
                value={username} onChange={e => setUsername(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Display name</label>
              <input className="form-input" placeholder="Your name"
                value={displayName} onChange={e => setDisplayName(e.target.value)} />
            </div>
          </>
        )}

        <div className="form-group">
          <label className="form-label">Email</label>
          <input className="form-input" type="email" placeholder="you@example.com"
            value={email} onChange={e => setEmail(e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">Password</label>
          <input className="form-input" type="password" placeholder="8+ characters"
            value={password} onChange={e => setPassword(e.target.value)} />
        </div>

        <button
          className="btn btn-primary"
          style={{ width:'100%' }}
          onClick={obsMode === 'login' ? loginObserver : registerObserver}
          disabled={loading || !email || !password}
        >
          {loading
            ? 'please wait...'
            : obsMode === 'login' ? 'sign in' : 'create observer account'
          }
        </button>
      </div>
    )
  }
}